module.exports = __webpack_public_path__ + "img/MEDIA054.eeb4c417.jpg";